import { materialIcons } from './material';
import { featherIcons } from './feather';

const icons = {
  material: materialIcons,
  feather: featherIcons,
};

export { icons };
